import { IGTMEventType } from "./IGTMEventType";
import { getCookie } from "../helpers/cookies";

export const checkIsMobile = (): boolean => {
  const userAgent = typeof window !== "undefined" ? (window?.navigator?.userAgent ?? window?.navigator?.vendor) : "";
  return /windows phone/i.test(userAgent) || /android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent);
};

let globalProperties = {
  device: checkIsMobile() ? "mobile" : "desktop",
  medium: "web",
  user_status: getCookie("BotB.Authenticated") === "true" ? "logged_in" : "logged_out",
};

let eventsQueue: any[] =
  typeof localStorage !== "undefined"
    ? localStorage.getItem("eventsQueue")
      ? JSON.parse(localStorage.getItem("eventsQueue") || "")
      : []
    : [];

export const sendEvent = (event: IGTMEventType, data = {}, options?: { shouldOnlyAppendToQueue: boolean }) => {
  // @ts-ignore
  const { eventCallback, eventTimeout, ...eventBodyData } = data;
  const message = {
    event,
    eventBody: {
      ...globalProperties,
      ...eventBodyData,
    },
  };
  if (options?.shouldOnlyAppendToQueue) {
    syncEventsQueue(message);
    return;
  }
  if (eventCallback) {
    // @ts-ignore
    message.eventCallback = eventCallback;
  }
  if (typeof eventTimeout === "number") {
    // @ts-ignore
    message.eventTimeout = eventTimeout;
  }
  pushToDataLayer(message);
};

export const sendCustomEvent = (event = {}, options?: { shouldOnlyAppendToQueue: boolean }) => {
  if (options?.shouldOnlyAppendToQueue) {
    syncEventsQueue(event);
    return;
  }
  // @ts-ignore
  if (event.eventCallback) {
    // @ts-ignore
    message.eventCallback = eventCallback;
  }
  // @ts-ignore
  if (typeof event.eventTimeout === "number") {
    // @ts-ignore
    message.eventTimeout = eventTimeout;
  }
  pushToDataLayer(event);
};

const pushToDataLayer = (message: any) => {
  window.dataLayer = window?.dataLayer || [];

  window.dataLayer.push(message);
  if (window.clarity) {
    window.clarity("event", message.event);
  }
};

export const pushQueueToDataLayer = () => {
  if (Array.isArray(eventsQueue)) {
    eventsQueue.forEach(event => {
      pushToDataLayer(event);
    });
    eventsQueue = [];
    localStorage.setItem("eventsQueue", JSON.stringify(eventsQueue));
  }
};

export const appendSourceParameter = <T>(isUpsell: boolean, existingParameters: Record<string, T> = {}) => {
  if (isUpsell) {
    return { ...existingParameters, source: "ftp" };
  }
  return existingParameters;
};

export const formatBillingPeriodForGTM = (period: string) => {
  switch (period.toLowerCase()) {
    case "year":
      return "yearly";
    case "month":
      return "monthly";
  }
  return period;
};

export const syncEventsQueue = (event: any) => {
  eventsQueue.push(event);
  localStorage.setItem("eventsQueue", JSON.stringify(eventsQueue));
};
